import { useQuery, type UseQueryResult } from 'react-query';
import { WarrantSharedService } from '@wealthlane/api-services/wealthlane-captable-service';
import { type OptionType } from '../../types/common';

const useGetWarrantSettlementTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<OptionType[] | undefined, unknown> => {
  return useQuery(
    ['getWarrantSettlementTypes'],
    async () => {
      const result = await handleRequest(
        WarrantSharedService.getApiCapTableApiAppWarrantSharedWarrantSettlementTypes()
      );
      return result ?? [];
    },
    {
      select: (data) => {
        return (data ?? []).map((item: any) => ({
          label: item.displayName ?? '',
          value: item.id ?? '',
        }));
      },
    }
  );
};

export default useGetWarrantSettlementTypes;
